module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-ties.2a7b9609.png";